import { render, staticRenderFns } from "./contactDetails.vue?vue&type=template&id=9f381c82&scoped=true"
import script from "./contactDetails.vue?vue&type=script&lang=js"
export * from "./contactDetails.vue?vue&type=script&lang=js"
import style0 from "./contactDetails.vue?vue&type=style&index=0&id=9f381c82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f381c82",
  null
  
)

export default component.exports